import { pickBy, negate, merge } from 'lodash';
class EntityService {
    constructor() {
        this.instanceDisplayPropsOrDefault = (entitySchema, context) => (entity) => {
            const defaultInstanceDisplayProps = {
                primaryText: entity._id,
                secondaryText: undefined,
                imageUrl: undefined,
            };
            let overrideInstanceDisplayProps;
            try {
                overrideInstanceDisplayProps = pickBy(entitySchema.options.instanceDisplayProps(entity, { context }), negate((a) => !Boolean(a)));
            }
            catch (error) { }
            return merge(defaultInstanceDisplayProps, overrideInstanceDisplayProps);
        };
    }
}
export const entityService = new EntityService();
